export default __webpack_public_path__ + "static/media/home.30c171f4.svg";